import {createSlice} from '@reduxjs/toolkit';
import moment from 'moment';
import { rowsPerPageJsonData } from '../utils/JsonData';


//here just create for miscellaneousChargesList


const initialState = {
    main_userType: 1,
    sms_tab: 0,
    sms_searchByText: 0,
    sms_searchUser: "",
    sms_userList: {},
    sms_receiverId: "",
    sms_unknownPhone: "",
    sms_chatData: [],
    sms_message: "",
    sms_senderId: "",
    sms_receiverData: {},
    sms_openAgreementDialog: false,
    sms_reservationData: [],
    sms_bookingId: "",
    sms_selectedBookingData: {},
    sms_chatArea: false,
    email_tab: 0,
    email_searchByText: 0,
    email_searchUser: "",
    email_userList: {},
    email_receiverId: "",
    email_unknownPhone: "",
    email_chatData: [],
    email_message: "",
    email_subject: "",
    email_senderId: "",
    email_receiverData: {},
    email_openAgreementDialog: false,
    email_reservationData: [],
    email_bookingId: "",
    email_selectedBookingData: {},
    email_chatArea: false,

    };

const chatSlice = createSlice({
    name: 'chat',
    initialState: initialState,
    reducers: {
       
        sms_tabSuccess: (state, action) => {
        state.sms_tab = action.payload;
        },
        sms_searchByTextSuccess: (state, action) => {
        state.sms_searchByText = action.payload;
        },
        sms_searchUserSuccess: (state, action) => {
        state.sms_searchUser = action.payload;
        },
        sms_userListSuccess: (state, action) => {
        state.sms_userList = action.payload;
        },
        sms_receiverIdSuccess: (state, action) => {
        state.sms_receiverId = action.payload;
        },
        sms_unknownPhoneSuccess: (state, action) => {
        state.sms_unknownPhone = action.payload;
        },
        sms_chatDataSuccess: (state, action) => {
        state.sms_chatData = action.payload;
        },
        sms_messageSuccess: (state, action) => {
        state.sms_message = action.payload;
        },
        sms_senderIdSuccess: (state, action) => {
        state.sms_senderId = action.payload;
        },
        sms_receiverDataSuccess: (state, action) => {
        state.sms_receiverData = action.payload;
        },
        sms_openAgreementDialogSuccess: (state, action) => {
        state.sms_openAgreementDialog = action.payload;
        },
        sms_reservationDataSuccess: (state, action) => {
        state.sms_reservationData = action.payload;
        },
        sms_bookingIdSuccess: (state, action) => {
        state.sms_bookingId = action.payload;
        },
        sms_selectedBookingDataSuccess: (state, action) => {
        state.sms_selectedBookingData = action.payload;
        },
        sms_chatAreaSuccess: (state, action) => {
        state.sms_chatArea = action.payload;
        },
        email_tabSuccess: (state, action) => {
            state.email_tab = action.payload;
            },
            email_searchByTextSuccess: (state, action) => {
            state.email_searchByText = action.payload;
            },
            email_searchUserSuccess: (state, action) => {
            state.email_searchUser = action.payload;
            },
            email_userListSuccess: (state, action) => {
            state.email_userList = action.payload;
            },
            email_receiverIdSuccess: (state, action) => {
            state.email_receiverId = action.payload;
            },
            email_unknownPhoneSuccess: (state, action) => {
            state.email_unknownPhone = action.payload;
            },
            email_chatDataSuccess: (state, action) => {
            state.email_chatData = action.payload;
            },
            email_messageSuccess: (state, action) => {
            state.email_message = action.payload;
            },
            email_subjectSuccess: (state, action) => {
            state.email_subject = action.payload;
            },
            email_senderIdSuccess: (state, action) => {
            state.email_senderId = action.payload;
            },
            email_receiverDataSuccess: (state, action) => {
            state.email_receiverData = action.payload;
            },
            email_openAgreementDialogSuccess: (state, action) => {
            state.email_openAgreementDialog = action.payload;
            },
            email_reservationDataSuccess: (state, action) => {
            state.email_reservationData = action.payload;
            },
            email_bookingIdSuccess: (state, action) => {
            state.email_bookingId = action.payload;
            },
            email_selectedBookingDataSuccess: (state, action) => {
            state.email_selectedBookingData = action.payload;
            },
            email_chatAreaSuccess: (state, action) => {
            state.email_chatArea = action.payload;
            },
        main_userTypeSuccess: (state, action) => {
        state.main_userType = action.payload;
        },
        
    }
});

export const {
    sms_tabSuccess,
    sms_searchByTextSuccess,
    sms_searchUserSuccess,
    sms_userListSuccess,
    sms_receiverIdSuccess,
    sms_unknownPhoneSuccess,
    sms_chatDataSuccess,
    sms_messageSuccess,
    sms_senderIdSuccess,
    sms_receiverDataSuccess,
    sms_openAgreementDialogSuccess,
    sms_reservationDataSuccess,
    sms_bookingIdSuccess,
    sms_selectedBookingDataSuccess,
    sms_chatAreaSuccess,
    email_tabSuccess,
    email_searchByTextSuccess,
    email_searchUserSuccess,
    email_userListSuccess,
    email_receiverIdSuccess,
    email_unknownPhoneSuccess,
    email_chatDataSuccess,
    email_messageSuccess,
    email_subjectSuccess,
    email_senderIdSuccess,
    email_receiverDataSuccess,
    email_openAgreementDialogSuccess,
    email_reservationDataSuccess,
    email_bookingIdSuccess,
    email_selectedBookingDataSuccess,
    email_chatAreaSuccess,
    main_userTypeSuccess,
} = chatSlice.actions;

export default chatSlice.reducer;
